import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import { accessRole } from '../../../../helpers/access_role'
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import { cancelToken } from "../../../../services/adapters/kepegawaian/penilaianService"
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import CreateBloc from './Blocs/CreateBloc'
import IndexBloc from '../Index/Blocs/IndexBloc'

let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
let peg_nip = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_nip : "";

if(accessRole('approve')){
    peg_uuid = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : "";
    peg_nip = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_nip : "";
}

class CreateView extends Component {

    createBloc = new CreateBloc()
    indexBloc = new IndexBloc()
    source
    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            domicile: 0,
            regionOption: [],
            provinceOption: [],
            cityOption: [],
        }
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'document') // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                employee_nip: peg_nip,
              employee_uuid : peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    getCity = (province_uuid) => {
        this.indexBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ cityOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })
        const query = { 
            is_local: 1,
            type : 3,
            parent_uuid : province_uuid
        }
        this.indexBloc.fetchRegionCity(query, this.source.token)
    }

    loadProvince = async () => {
        const query = { 
            parent_uuid: '61b47307-167d-489f-bb6c-c1c9662acab3',
            type: 2
        }
        await this.indexBloc.fetchRegionProvince(query, this.source.token)
    }

    loadRegion = async () => {
        const query = { type: 1 }
        await this.indexBloc.fetchRegion(query, this.source.token)
    }


    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadRegion()
        this.loadProvince()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ provinceOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.regionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ regionOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        this.indexBloc.regionChannel?.unsubscribe()
        this.indexBloc.regionCityChannel?.unsubscribe()
        this.indexBloc.regionProvinceChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="penilaian"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`?penilaian`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Tambah Penilaian</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTahun"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tahun Penilaian <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="ratting_year"
                                                    placeholder="Tahun Penilaian"
                                                    errorMessage="Masukkan Tahun Penilaian"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldTahun"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldKesetiaan"
                                                className="col-md-2 col-form-label"
                                            >
                                                Kesetiaan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="ratting_loyalty"
                                                    placeholder="Kesetiaan"
                                                    errorMessage="Masukkan Nilai Kesetiaan"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldKesetiaan"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldPrestasi"
                                                className="col-md-2 col-form-label"
                                            >
                                                Prestasi <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="ratting_performance"
                                                    placeholder="Prestasi"
                                                    errorMessage="Masukkan Nilai Prestasi"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldPrestasi"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTanggungJawab"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggung Jawab <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="ratting_responsibility"
                                                    placeholder="Tanggung Jawab"
                                                    errorMessage="Masukkan Nilai Tanggung Jawab"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldTanggungJawab"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldKetaatan"
                                                className="col-md-2 col-form-label"
                                            >
                                                Ketaatan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="ratting_obedience"
                                                    placeholder="Ketaatan"
                                                    errorMessage="Masukkan Nilai Ketaatan"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldKetaatan"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldKejujuran"
                                                className="col-md-2 col-form-label"
                                            >
                                                Kejujuran <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="ratting_honesty"
                                                    placeholder="Kejujuran"
                                                    errorMessage="Masukkan Nilai Kejujuran"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldKejujuran"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldKerjasama"
                                                className="col-md-2 col-form-label"
                                            >
                                                Kerjasama <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="ratting_cooperation"
                                                    placeholder="Kerjasama"
                                                    errorMessage="Masukkan Nilai Kerjasama"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldKerjasama"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldPrakarsa"
                                                className="col-md-2 col-form-label"
                                            >
                                                Prakarsa <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="ratting_initiative"
                                                    placeholder="Prakarsa"
                                                    errorMessage="Masukkan Nilai Prakarsa"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldPrakarsa"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldKepemimpinan"
                                                className="col-md-2 col-form-label"
                                            >
                                                Kepemimpinan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="ratting_leadership"
                                                    placeholder="Kepemimpinan"
                                                    errorMessage="Masukkan Nilai Kepemimpinan"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldKepemimpinan"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldJumlah"
                                                className="col-md-2 col-form-label"
                                            >
                                                Jumlah <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="ratting_amount"
                                                    placeholder="Jumlah"
                                                    errorMessage="Masukkan Nilai Jumlah"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldJumlah"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldRata-Rata"
                                                className="col-md-2 col-form-label"
                                            >
                                                Rata-Rata <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="ratting_average"
                                                    placeholder="Rata-Rata"
                                                    errorMessage="Masukkan Nilai Rata-Rata"
                                                    type="number"
                                                    className="form-control"
                                                    id="fieldRata-Rata"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                       
                                       <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="6">
                                            
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                                {' '}
                                                <Link to="/kepegawaian/home.html?penilaian">
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                             
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?penilaian'/>
                : null }
            </Fragment>
        )
    }

}

export default CreateView